module.exports = __webpack_public_path__ + "static/home_header_2-9ad860add7db596d06afacc2231dfe5a.png";